// src/Common/Loader.tsx
import React from 'react';
import { Grid } from 'react-loader-spinner';

const Loader: React.FC = () => {
    return (
        <div
            style={{
                height: '100vh',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'rgba(255, 255, 255, 0.8)', // Light overlay
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 9999,
            }}
        >
            <Grid
                height="80"
                width="80"
                color="#B7002A"
                ariaLabel="grid-loading"
                radius="12.5"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            />
        </div>
    );
};

export default Loader;
